import {
  getGalleryList,
  pathCreateGallery,
  pathDeleteGallery,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { galleryActions } from "../reducers/gallery";
import { toast } from "react-toastify";
import { t } from "i18next";

export const fetchGalleryList = (id_gallery = 0) => {
  return (dispatch) => {
    return apiService
      .get(getGalleryList(id_gallery))
      .then((response) => {
        id_gallery == 0
          ? dispatch(galleryActions.fetchGalleryList(response.data))
          : dispatch(galleryActions.fetchGalleryDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const createNewGallery = (data, navigate) => {
  return async () => {
    try {
      const response = await apiService.postMultipart(
        pathCreateGallery(),
        data
      );
      navigate("/gallery-list");
      toast.success(t("galleryListActions.created"), { theme: "colored" });
    } catch (err) {
      handleError(err);
    }
  };
};

export const createNewGallery1 = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .postMultipart(pathCreateGallery(), data)
      .then((response) => {
        // dispatch(galleryActions.fetchGalleryList(response.data));
        toast.success(t("galleryListActions.created"), {
          theme: "colored",
        });
        navigate("/gallery-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchEditGallery = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .putMultipart(pathCreateGallery(), data)
      .then((response) => {
        // dispatch(galleryActions.fetchGalleryList(response.data));
        toast.success(t("galleryListActions.updated"), {
          theme: "colored",
        });
        navigate("/gallery-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchDeleteGallery = (id) => {
  return (dispatch) => {
    return apiService
      .delete(pathDeleteGallery(id))
      .then((response) => {
        toast.success(t("galleryListActions.deleted"), {
          theme: "colored",
        });

        dispatch(fetchGalleryList(0));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

const handleError = (err) => {
  let errorMessage = err.response ? err.response.data.message : err;
  if (!err.response) {
    toast.error(t("actions.error.refreshPage") + err.response, {
      theme: "colored",
    });
  }
  toast.error(errorMessage, { theme: "colored" });
};
